module.exports = __webpack_public_path__ + "static/logo-lazaridis-ss-ba42078c84dc5ae075fb6e716d179bb4.png";